import {
  Enum_Article_Category,
  GetFilteredSortedArticlesQueryVariables,
  GetTotalFilteredArticlesQueryVariables
} from '@/gql/generated/graphql'
import { createSearchParamsCache, parseAsArrayOf, parseAsInteger, parseAsString, parseAsStringEnum } from 'nuqs/server'

export const NUM_ARTICLES_PER_PAGE = 21

export enum ValidArticleSorts {
  newest = 'Newest to oldest',
  oldest = 'Oldest to newest'
}

export const constructFullArticlesSort = (sortOrder: ValidArticleSorts): string[] => {
  switch (sortOrder) {
    case ValidArticleSorts.newest:
      return ['originallyPublished:desc', 'updatedAt:desc']
    case ValidArticleSorts.oldest:
      return ['originallyPublished:asc', 'updatedAt:asc']
    default:
      return ['']
  }
}

export const constructArticlesCategoryFilter = (filterVal: Enum_Article_Category) => {
  switch (filterVal) {
    case Enum_Article_Category.Education:
      return { category: { eq: Enum_Article_Category.Education } }
    case Enum_Article_Category.Interview:
      return { category: { eq: Enum_Article_Category.Interview } }
    case Enum_Article_Category.News:
      return { category: { eq: Enum_Article_Category.News } }
    case Enum_Article_Category.Podcast:
      return { category: { eq: Enum_Article_Category.Podcast } }
    case Enum_Article_Category.Video:
      return { category: { eq: Enum_Article_Category.Video } }
    default:
      return {}
  }
}

export const constructFullArticlesCategoryFilter = (filter: string[]) => {
  if (filter.length === 0) return {}
  const filterObj = filter.map((f) => constructArticlesCategoryFilter(f as Enum_Article_Category))
  return { or: filterObj }
}

export const INITIAL_ARTICLES_GRID_PAGE_VARIABLES = {
  filter: {},
  sort: ValidArticleSorts.newest,
  pagination: { page: 1, pageSize: NUM_ARTICLES_PER_PAGE }
}

export const articleFilterParsers = {
  sort: parseAsStringEnum(Object.values(ValidArticleSorts)).withDefault(ValidArticleSorts.newest),
  page: parseAsInteger.withDefault(1),
  categoryFilterValue: parseAsArrayOf(parseAsString).withDefault([])
}

export const articleFilterCache = createSearchParamsCache(articleFilterParsers)

export function constructGetTotalFilteredArticlesQueryVariables(
  categoryFilterValue: string[]
): GetTotalFilteredArticlesQueryVariables {
  return {
    filter: constructFullArticlesCategoryFilter(categoryFilterValue)
  }
}

export function constructGetFilteredSortedArticlesQueryVariables(
  categoryFilterValue: string[],
  sortOrder: ValidArticleSorts,
  pageNumber: number
): GetFilteredSortedArticlesQueryVariables {
  return {
    filter: constructFullArticlesCategoryFilter(categoryFilterValue),
    sort: constructFullArticlesSort(sortOrder),
    pagination: { page: pageNumber, pageSize: NUM_ARTICLES_PER_PAGE }
  }
}
